import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40c9c8c6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c9c8c6')) {
      api.createRecord('40c9c8c6', component.options)
    } else {
      api.reload('40c9c8c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40c9c8c6&", function () {
      api.rerender('40c9c8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/index.vue"
export default component.exports